// extracted by mini-css-extract-plugin
module.exports = {"accordion-content":"DirectDebitStyles_accordion-content__bgOUA"};